import React from 'react';
import Link from 'next/link';

const YEMEN_EMBLEM = 'https://media.base44.com/images/public/69ed0fe31d3c9ede3b821281/406079c5f_Emblem_of_Yemen_2svg.png';

const quickLinks = [
  { href: '/', label: 'الرئيسية' },
  { href: '/services', label: 'جميع الخدمات' },
  { href: '/apply', label: 'تقديم طلب' },
  { href: '/track', label: 'تتبع الطلب' },
  { href: '/faq', label: 'الأسئلة الشائعة' },
  { href: '/contact', label: 'تواصل معنا' },
];

const serviceLinks = [
  { href: '/services#visa', label: 'خدمات التأشيرات' },
  { href: '/services#passport', label: 'خدمات جواز السفر' },
  { href: '/services#consular', label: 'الخدمات القنصلية' },
  { href: '/services#authentication', label: 'تصديق الوثائق' },
  { href: '/services#diplomatic', label: 'خدمات البعثات' },
  { href: '/services#official-visits', label: 'الزيارات الرسمية' },
];

export default function Footer() {
  return (
    <footer className="bg-primary text-white font-tajawal" dir="rtl">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-10">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <img src={YEMEN_EMBLEM} alt="شعار اليمن" className="w-12 h-12 object-contain" />
              <div>
                <div className="font-bold text-base leading-tight">وزارة الخارجية اليمنية</div>
                <div className="text-xs text-white/60 leading-tight">منصة تصريح</div>
              </div>
            </div>
            <p className="text-sm text-white/65 leading-relaxed max-w-xs">
              البوابة الرسمية لخدمات التأشيرات وجوازات السفر والخدمات القنصلية للجمهورية اليمنية.
            </p>
            <div className="mt-4 flex items-center gap-2">
              <span className="badge-official text-xs">🇧🇴 بوابة حكومية رسمية</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold mb-5 text-sm uppercase tracking-wider text-white/80 border-b border-white/10 pb-2">روابط سريعة</h4>
            <div className="space-y-2.5">
              {quickLinks?.map((link) => (
                <Link
                  key={link?.href}
                  href={link?.href}
                  className="block text-sm text-white/60 hover:text-white transition-colors hover:translate-x-1 rtl:hover:-translate-x-1 duration-150"
                >
                  {link?.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-bold mb-5 text-sm uppercase tracking-wider text-white/80 border-b border-white/10 pb-2">الخدمات</h4>
            <div className="space-y-2.5">
              {serviceLinks?.map((link) => (
                <Link
                  key={link?.href}
                  href={link?.href}
                  className="block text-sm text-white/60 hover:text-white transition-colors duration-150"
                >
                  {link?.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-bold mb-5 text-sm uppercase tracking-wider text-white/80 border-b border-white/10 pb-2">تواصل معنا</h4>
            <div className="space-y-3 text-sm text-white/65">
              <div className="flex items-start gap-2">
                <svg className="w-4 h-4 mt-0.5 shrink-0 text-white/40" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                <span>عدن، الجمهورية اليمنية</span>
              </div>
              <div className="flex items-center gap-2">
                <svg className="w-4 h-4 shrink-0 text-white/40" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                <span dir="ltr" className="text-right">+967 2 234 567</span>
              </div>
              <div className="flex items-center gap-2">
                <svg className="w-4 h-4 shrink-0 text-white/40" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                <span dir="ltr" className="text-right">info@mofa.gov.ye</span>
              </div>
              <div className="mt-4 pt-4 border-t border-white/10">
                <p className="text-xs text-white/50 mb-2">ساعات العمل</p>
                <p className="text-xs text-white/65">الأحد — الخميس: 8:00 ص — 4:00 م</p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-6">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-white/50">
            <div className="flex items-center gap-2">
              <span>🇧🇴 وزارة الخارجية — الجمهورية اليمنية</span>
            </div>
            <div className="flex items-center gap-4">
              <Link href="/privacy" className="hover:text-white/80 transition-colors">سياسة الخصوصية</Link>
              <Link href="/terms" className="hover:text-white/80 transition-colors">شروط الاستخدام</Link>
              <Link href="/contact" className="hover:text-white/80 transition-colors">تواصل معنا</Link>
            </div>
            <span>© 2026 جميع الحقوق محفوظة</span>
          </div>
          <div className="text-center mt-4 text-xs text-white/35 flex items-center justify-center gap-1">
            <span>صُنع بحب في</span>
            <svg className="w-3 h-3 text-red-400 fill-red-400 inline" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 21.593c-5.63-5.539-11-10.297-11-14.402 0-3.791 3.068-5.191 5.281-5.191 1.312 0 4.151.501 5.719 4.457 1.59-3.968 4.464-4.447 5.726-4.447 2.54 0 5.274 1.621 5.274 5.181 0 4.069-5.136 8.625-11 14.402z"/>
            </svg>
            <span>في Network Systems Co.</span>
            <a href="https://www.net4sys.com" target="_blank" rel="noopener noreferrer" className="hover:text-white/60 underline" dir="ltr">www.net4sys.com</a>
            <span dir="ltr">@2026</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
